/*
    This is the container for selecting scenes
*/

import React from 'react'
import { func, number } from 'prop-types'
import { connect } from 'react-redux'

import { openComposition } from 'models/compositions/actions'
import { compositionsToggle } from 'models/ui/actions'
import { compositionDataItemsType } from 'models/propTypes'

import { getCompositionsData, getSelectedCompositionId } from 'models/compositions/selectors'

import CompositionSelection from 'components/CompositionSelection'

const CompositionSelectionContainer = ({ compositionDataItems, onOpenComposition, selectedCompositionId, close }) => (
    <CompositionSelection
        compositionDataItems={compositionDataItems}
        onOpenComposition={onOpenComposition}
        selectedCompositionId={selectedCompositionId}
        close={close}
    />
)

CompositionSelectionContainer.propTypes = {
    compositionDataItems: compositionDataItemsType.isRequired,
    onOpenComposition: func.isRequired,
    selectedCompositionId: number.isRequired,
    close: func.isRequired,
}

const mapStateToProps = (state) => ({
    compositionDataItems: getCompositionsData(state),
    selectedCompositionId: getSelectedCompositionId(state),
})

const mapDispatchToProps = (dispatch) => ({
    onOpenComposition: (id, trackingInfo) => dispatch(openComposition(id, trackingInfo)),
    close: () => dispatch(compositionsToggle()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CompositionSelectionContainer)
